import * as queryParams from 'qs';
import { request } from '../axios/request';
import {
  CLEAR_SIGNUP_STATE,
  FETCH_SIGNUP_FULFILLED,
  FETCH_SIGNUP_PENDING,
  FETCH_SIGNUP_REJECTED,
  SIGNUP_SMS_VERIFICATION_FORM_HIDE,
  SIGNUP_SMS_VERIFICATION_FORM_SHOW,
} from '../constants/signup';

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const okConditions = [200, 201, 202, 204];
let isSmsValidationStep = false;

const hasNeedSms = ({ status }) => {
  isSmsValidationStep = true
  return okConditions.includes(status);
};

const isCompleted = ({ status }) => {
  return okConditions.includes(status);
};

export const completeDispatcher = (response) => (dispatch) => {
  dispatch(fulfilled(response));
  dispatch(hideModalAction());
};

const pending = () => ({
  type: FETCH_SIGNUP_PENDING,
});

const rejected = ({ response: { data } }) => ({
  type: FETCH_SIGNUP_REJECTED,
  data,
});

const fulfilled = (data) => ({
  type: FETCH_SIGNUP_FULFILLED,
  data,
});

export const showModalAction = () => ({
  type: SIGNUP_SMS_VERIFICATION_FORM_SHOW,
});

export const hideModalAction = () => {
  isSmsValidationStep = false
  return {
    type: SIGNUP_SMS_VERIFICATION_FORM_HIDE,
  };
};

export const clearSignupState = () => ({
  type: CLEAR_SIGNUP_STATE,
})

export const sendForm = (data) => (dispatch) => {
  dispatch(pending());

  request({
    url: $U.CUSTOMER_REGISTER,
    method: 'POST',
    data: queryParams.stringify(data),
  })
    .then((response) => {
      if (
        !isSmsValidationStep &&
        hasNeedSms(response) &&
        response.status !== 201
      ) {
        dispatch(showModalAction());
        return;
      }

      if (isCompleted(response)) {
        dispatch(completeDispatcher(response));
      }
    })
    .catch((error) => dispatch(rejected(error)));
};



// WEBPACK FOOTER //
// ./src/actions/signup.js